var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIndustry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M32.994 43.128c-4.172 0-7.796 1.603-9.62 3.955H9.314a4 4 0 0 0-4 4v7.863h54.372v-7.863a4 4 0 0 0-4-4H42.615c-1.824-2.352-5.448-3.955-9.62-3.955Zm-.184 9.926a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    fillRule: "evenodd",
    d: "M22.492 17.372a7.15 7.15 0 1 0-9.228 3.602L23.83 41.71c1.993-1.548 4.916-2.525 8.174-2.525.56 0 1.109.03 1.645.085L22.492 17.372Zm-3.76-3.005a2.728 2.728 0 1 1-5.457 0 2.728 2.728 0 0 1 5.456 0Zm13.272 29.761c.764 0 1.462.29 1.988.765l-4.938 2.516a2.966 2.966 0 0 1 2.95-3.28Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    d: "M38.315 12.283a3 3 0 0 1 2.139-2.874l7.86-2.354v15l-7.863-2.363a3 3 0 0 1-2.136-2.873v-4.536Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    d: "m40.315 13.21 8.131-8.131 3.89 3.89-8.132 8.13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    d: "m40.315 15.944 8.131 8.132 3.89-3.89-8.132-8.131zM48.472 5.055h11v4.5h-11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C5684",
    d: "M48.472 24.1h11v-4.5h-11zM20 12h20v5H20z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustry);
export default __webpack_public_path__ + "static/media/icon-industry.bb1858f5a861962cafeb266c54481c12.svg";
export { ForwardRef as ReactComponent };